export function resolveStorageVendor(options, originalName) {
  const name = String(originalName ?? '').trim();
  if (!name) return { name: '', option: null, warning: '' };
  const matches = options.filter(option =>
    String(option.manufacturer_AbbreviationName ?? '').trim() === name
  );
  if (matches.length === 1) return { name, option: matches[0], warning: '' };
  return {
    name,
    option: { manufacturer_Seq: '', manufacturer_AbbreviationName: name },
    warning: matches.length > 1
      ? `廠商「${name}」有多筆同名資料，已保留原始名稱，請確認廠商資料。`
      : `找不到名稱完全相同的廠商「${name}」，已保留原始名稱，請確認廠商資料。`,
  };
}
